import React, { memo } from 'react';
import { ATTENTION_COLOR, DISTRIBUTION_TYPE } from '../../utils/Constants';
import styles from './style.module.css';
import { OrderTicket } from 'types';

const AdultSvg = ({ x, y, size, fillColor }: { x: number; y: number; size: number; fillColor: string }) => {
    const stroke = fillColor === ATTENTION_COLOR ? '#000' : '#00000000';
    return (
        <svg x={x} y={y} height={size} width={size} viewBox={`0, 0, 170, 170`} fill={fillColor}>
            <g id="text">
                <path d="M17.12,12.21A6.11,6.11,0,1,0,11,6.1a6.1,6.1,0,0,0,6.1,6.11" stroke={stroke} strokeWidth="1" />
                <path
                    d="M24.82,14.34a73.31,73.31,0,0,0-15.39,0c-5,.93-7.71,5.16-8.22,10.43L0,46.26H4.36l3-20.55h0V81.86H12.6l4.11-34.79H18l3.63,34.79h5.25V25.71h0l3,20.55h4.36L33,24.77c-.38-5.15-3.18-9.5-8.21-10.43"
                    stroke={stroke}
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

/**
 * 人数を表示する。
 */
type DisplayNumberProps = {
    orderTicket: OrderTicket;
    textColor: string;
    circleSize?: number;
};
const DisplayNumber = memo(({ orderTicket, textColor, circleSize }: DisplayNumberProps) => {
    const { numberAdults, numberCustom1, numberCustom2, numberCustom3, distributionType, remainingOrderDistribution } =
        orderTicket ?? {};

    let displayNumberAdults = numberAdults;
    let displayNumberCustom1 = numberCustom1;
    let displayNumberCustom2 = numberCustom2;
    let displayNumberCustom3 = numberCustom3;

    if (distributionType === DISTRIBUTION_TYPE.ENABLE || distributionType === DISTRIBUTION_TYPE.REQUIRED) {
        const { remainingNumberAdults, remainingNumberCustom1, remainingNumberCustom2, remainingNumberCustom3 } =
            remainingOrderDistribution ?? {};
        displayNumberAdults = remainingNumberAdults ?? 0;
        displayNumberCustom1 = remainingNumberCustom1 ?? 0;
        displayNumberCustom2 = remainingNumberCustom2 ?? 0;
        displayNumberCustom3 = remainingNumberCustom3 ?? 0;
    }

    const size = 200;
    const y = 130; // 高さ基準
    const { totalNumber, fillColor } = (() => {
        let totalNumber = 0;
        let fillColor = textColor;
        if (displayNumberAdults != null) {
            totalNumber += displayNumberAdults;
        }
        if (displayNumberCustom1 != null) {
            totalNumber += displayNumberCustom1;
            fillColor = ATTENTION_COLOR;
        }
        if (displayNumberCustom2 != null) {
            totalNumber += displayNumberCustom2;
            fillColor = ATTENTION_COLOR;
        }
        if (displayNumberCustom3 != null) {
            totalNumber += displayNumberCustom3;
            fillColor = ATTENTION_COLOR;
        }
        return { totalNumber, fillColor };
    })();

    return (
        <div className={styles.container}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 ${size} ${size}`}
                width={`${circleSize ?? 300}px`}
                height={`${circleSize ?? 300}px`}
            >
                <AdultSvg x={size / 2 - 22} y={y - 2} size={70} fillColor={fillColor} />

                <text
                    fill={fillColor}
                    fontSize={45}
                    x={size / 2}
                    y={y + 32}
                    textAnchor="start"
                    fontFamily="NotoSans"
                    fontWeight="bold"
                    stroke={fillColor === ATTENTION_COLOR ? '#000' : '#00000000'}
                    strokeWidth="0.5"
                >
                    {totalNumber}
                </text>
            </svg>
        </div>
    );
});

export default DisplayNumber;
